import { useContext } from "react"
import { BasketContext } from "../contexts/BasketContexts"

const color = {color: "gray"};
const background = {background: "none"}
export const MovieCard = ({movie, onExpand}) => {
  const {basket,setBasket} = useContext(BasketContext)

  const basketClick = () =>
  {
    setBasket((basket) =>{
      
      return [...basket, movie]
    })
  }

  const tooltip = `${movie.imdbID}-tooltip`;

  if (movie.stock > 0 && movie.stock < 10)
  {
      window.$(`#${tooltip}`).tooltip("enable");
  }

    return <div className="movieCard">
        
    <div class="card-head">
    <img src={movie.poster} className="img-fluid" onClick={onExpand}/>
  
    <div class="card-body">
    <h3 class="card-title">{movie.title}</h3>
    <span class="year">({movie.year})</span>

    <div class="card-info">
      <span class="price">£{movie.price}</span>
      {/* <span class="stock">Quantity: {movie.stock}</span> */}
      {movie.stock < 1
        ? <button class="btns" id="disabled" disabled style={{...color, ...background}} >Out of Stock</button>
        : <button className="btns" id={tooltip} onClick={basketClick} data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title={`Only ${movie.stock} in stock!`}>Add to basket</button>
      }
    
    
    </div>
  </div>
  </div>

    </div>
   
}
